module.exports = {
    cart: {
        clearTrolleyConfirmationMessage:
            'Are you sure you would like to remove all products from the cart?',
        expressUnavailableHeader:
            'Delivery Now is currently unavailable',
        meatStockLossMessage:
            'Weight is approximate. We won\'t overcharge you if we give you more, and we\'ll refund the difference if it\'s less.',
        removeAllProductsLinkText:
            'Remove all products',
        estimatedDeliveryFee: '$0.00 - $19.00',
        deliveryFeeOptionLink:
            'https://www.woolworths.com.au/shop/discover/shopping-online/delivery',
        estimatedPackagingFee: '$0.00 - $2.50',
        packagingFeeOptionLink:
            'https://www.woolworths.com.au/shop/discover/reusable-bags',
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/cart.js